import React from 'react';

const MidBanner = ({ title, subtitle, cta, image }) => {
  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="relative h-64 md:h-80 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            <div className="text-center text-white">
              <h3 className="text-3xl md:text-4xl font-bold mb-2">{title}</h3>
              <p className="text-lg mb-4">{subtitle}</p>
              <button className="px-6 py-2 bg-accent hover:bg-accent-dark transition-colors font-semibold">
                {cta}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidBanner;